import { StyleSheet } from 'aphrodite';
import COLORS from '../../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    height: 32,
    justifyContent: 'center',
    borderRadius: 6,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 12,
    display: 'flex',
    fontWeight: 'bold',
    color: COLORS.pastelBlue,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    background: 'white',
    border: '1px solid rgba(0,0,0,0.08)',
    ':hover': {
      background: 'rgba(0,0,0,0.02)',
      border: '1px solid rgba(0,0,0,0.12)',
      cursor: 'pointer'
    },
    ':active': {
      background: `${Color(COLORS.pastelBlue).lighten(0.5)}`,
      border: `1px solid ${Color(COLORS.pastelBlue).lighten(0.32)}`,
    },
    'user-select': 'none'
  },
  rootLoading: {
    color: 'gray',
    ':hover': {
      background: 'white',
      border: '1px solid rgba(0,0,0,0.08)',
      cursor: 'default'
    }
  },
  rootDisabled: {
    color: '#c1c1c1',
    ':hover': {
      background: 'white',
      border: '1px solid rgba(0,0,0,0.08)',
      cursor: 'default'
    }
  },
  titleLoading: {
    opacity: 0
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/button/button-styles.js